import { Suspense, memo } from 'react';
import type { FC } from 'react';

import type { LoadingWrapperVariant } from './loadingWrapper/loadingWrapper';
import { LoadingWrapper } from './loadingWrapper/loadingWrapper';
import { withScrollRestoration } from './withScrollRestoration/withScrollRestoration';

export const Loader = <TProps extends object>(
  Component: FC<TProps>,
  variant?: LoadingWrapperVariant
) => {
  const ScrollRestoringComponent = withScrollRestoration(Component);
  const componentName = Component.displayName || Component.name || 'Component';

  const LoaderComponent = memo(
    ({
      restoreScroll = false,
      ...componentProps
    }: TProps & { restoreScroll?: boolean }) => {
      const WrappedComponent: FC<TProps> = restoreScroll
        ? ScrollRestoringComponent
        : Component;

      return (
        <Suspense
          fallback={
            <LoadingWrapper isLoading variant={variant || 'full-page'} />
          }
        >
          <WrappedComponent {...(componentProps as TProps)} />
        </Suspense>
      );
    }
  );
  LoaderComponent.displayName = `Loader(${componentName})`;

  return LoaderComponent;
};
